import { render, staticRenderFns } from "./EventFlow.vue?vue&type=template&id=84c0c0ce&scoped=true"
import script from "./EventFlow.vue?vue&type=script&lang=ts"
export * from "./EventFlow.vue?vue&type=script&lang=ts"
import style0 from "./EventFlow.vue?vue&type=style&index=0&id=84c0c0ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c0c0ce",
  null
  
)

export default component.exports